import styled from 'styled-components';

import { Col } from 'components/grid';

import Link from 'components/link';
import Button from 'components/button';

const PageWrapper = styled.div`
  flex-direction: column;
  height: 100%;
  display: flex;
`;

const Subtitle = styled.h3`
  ${({ theme }) => theme.typograph.paragraphMedium}
  color: ${({ theme }) => theme.colors.mainColorContrast};
  margin-bottom: 16px;
  margin-top: ${({ marginTop }) => (marginTop ? '16px' : 'unset')};
`;

const StyledCheckBoxPanel = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 8px;
  width: 100%;
`;

const StyledCol = styled(Col)`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  padding-right: 16px;
`;

const StyledCheckBoxPanelTitle = styled.div`
  background: ${({ theme }) => theme.colors.contrastColorBackground};
  ${({ theme }) => theme.typograph.paragraphMedium}
  color: ${({ theme }) => theme.colors.mainColorContrast};
  text-transform: uppercase;
  padding-left: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
`;

const StyledCheckBoxPanelBody = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

const StyledCheckBoxPanelBodyText = styled.span`
  ${({ theme }) => theme.typograph.descriptionRegular}
  color: ${({ theme }) => theme.colors.textColorSecondary};
`;

const StyledCheckBoxPanelBodyItems = styled.div`
  ${({ theme }) => theme.typograph.paragraphRegular}
  max-height: 215px;
  min-height: 215px;
  width: 100%;
  padding-top: 16px;
  overflow-y: auto;
`;

const StyledCheckBox = styled.input`
  margin-right: 16px;
  width: 18px;
  height: 18px;
`;

const StyledCheckBoxItem = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

const StyledCheckBoxPanelFooter = styled.div`
  ${({ theme }) => theme.typograph.paragraphRegular}
  color: ${({ theme }) => theme.colors.textColorSecondary};

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;

  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
`;
const StyledCheckAllButton = styled(Link)`
  margin: 16px 0px;
`;

const ColSave = styled(Col)`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
`;

const ButtonSave = styled(Button)`
  margin-right: 16px;
`;

export {
  PageWrapper,
  Subtitle,
  StyledCheckAllButton,
  StyledCheckBox,
  StyledCheckBoxPanel,
  StyledCheckBoxPanelTitle,
  StyledCheckBoxPanelBody,
  StyledCheckBoxPanelBodyItems,
  StyledCheckBoxPanelFooter,
  StyledCheckBoxItem,
  StyledCol,
  ColSave,
  ButtonSave,
  StyledCheckBoxPanelBodyText,
};
